module.exports = __webpack_public_path__ + "img/retaildigitalplatform.6a62f458.jpg";